// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1247":"7e78985319ab4d1d","8698":"e2261cb685b245f4"}[chunkId] + ".js";
};